import { fr } from 'date-fns/locale';
const dateFrFR = {
  name: 'fr-FR',
  locale: fr
};
export default dateFrFR;